// Empty ("None") modules have no erpItemNumber, so this is the tiebreaker between
// differently-sized empty modules of the same item type — but the relevant dimension
// field differs per type
export const isSameEmptyModuleSize = (
  itemType: string,
  propsA: { moduleHeight?: number; openingWidth?: number; openingHeight?: number } | undefined,
  propsB: { moduleHeight?: number; openingWidth?: number; openingHeight?: number } | undefined
): boolean => {
  switch (itemType) {
    case 'window':
      return propsA?.moduleHeight === propsB?.moduleHeight
    case 'garage-door':
    case 'double-door':
    case 'sliding-door':
    case 'facade-section':
      return propsA?.openingWidth === propsB?.openingWidth && propsA?.openingHeight === propsB?.openingHeight
    default:
      return true
  }
}
